import React from 'react';

const About = () => {
  return (
    <section id="about" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Your Business Systems Partner</h2>
          <div className="w-20 h-1 bg-primary mx-auto mb-8"></div>
          <p className="max-w-3xl mx-auto text-lg text-gray-700">
            We are a business systems partner. We help teams understand where their processes are slowing them down, and build automated tech tools that fix them. Our goal isn't just code — it's measurable business growth.
          </p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-10">
          <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow">
            <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mb-6">
              <i className="ri-line-chart-line ri-xl text-primary"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Process Discovery & Analysis</h3>
            <p className="text-gray-700">We identify bottlenecks in your operations and design solutions that deliver measurable improvements in efficiency and cost savings.</p>
          </div>
          
          <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow">
            <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mb-6">
              <i className="ri-lightbulb-line ri-xl text-primary"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Business-First Approach</h3>
            <p className="text-gray-700">We focus on solving real business problems, not just implementing technology. Every solution is designed to improve your bottom line.</p>
          </div>
          
          <div className="bg-white p-8 rounded-lg shadow-md hover:shadow-lg transition-shadow">
            <div className="w-14 h-14 bg-primary/10 rounded-full flex items-center justify-center mb-6">
              <i className="ri-bar-chart-box-line ri-xl text-primary"></i>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-3">Measurable Results</h3>
            <p className="text-gray-700">We track ROI and business impact. Our success is measured by time saved, costs reduced, and revenue growth enabled.</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
